export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Você preenche o formulário',
      description: 'Conte sobre sua rotina, objetivos, histórico de treinos e preferências',
      icon: 'ri-file-text-line'
    },
    {
      number: '2',
      title: 'Raíssa analisa seu caso individualmente',
      description: 'Análise completa do seu perfil para criar a estratégia perfeita',
      icon: 'ri-search-eye-line'
    },
    {
      number: '3',
      title: 'Você recebe seu treino personalizado',
      description: 'Treino 100% customizado para seus objetivos e disponibilidade',
      icon: 'ri-file-download-line'
    },
    {
      number: '4',
      title: 'Envia feedback semanal',
      description: 'Compartilhe sua evolução, dificuldades e sensações dos treinos',
      icon: 'ri-chat-3-line'
    },
    {
      number: '5',
      title: 'Evolui com ajustes contínuos durante 30 dias',
      description: 'Receba ajustes personalizados baseados no seu progresso real',
      icon: 'ri-trophy-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 via-white to-purple-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat">
            Como Funciona <span className="text-purple-600">Na Prática</span>
          </h2>
          <p className="text-xl text-gray-600 font-poppins">
            Um processo simples e eficiente para sua transformação
          </p>
        </div>
        
        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-purple-300 to-purple-500 rounded-full"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`flex items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } flex-col lg:space-x-8`}
              >
                {/* Content */}
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'} text-center lg:text-left mb-8 lg:mb-0`}>
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-purple-100">
                    <div className="flex items-center justify-center lg:justify-start mb-4">
                      <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                        <i className={`${step.icon} text-purple-600 text-xl`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 font-poppins">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-gray-600 leading-relaxed font-inter">
                      {step.description}
                    </p>
                  </div>
                </div>
                
                {/* Step Number */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-2xl font-bold text-white font-montserrat">{step.number}</span>
                  </div>
                </div>
                
                {/* Spacer for alternating layout */}
                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
